import { captureException } from './errorTracking';

/**
 * Client-side error reporter.
 *
 * - Always logs the error to the console (dev visibility).
 * - In production, forwards the error to PostHog via `captureException`. PostHog
 *   autocaptures `window.error` / `unhandledrejection` once it loads, so callers
 *   only need to invoke `reportError()` from contexts that aren't covered by
 *   those handlers (notably React's `<ErrorBoundary onError>` and the
 *   `createRoot` error hooks, which catch render errors before `window.error`).
 */
export interface ReportInfo {
  // React's `ErrorInfo.componentStack` is `string | null | undefined`, so
  // accept all three to make this compatible with `<ErrorBoundary onError>`.
  componentStack?: string | null | undefined;
}

export function reportError(error: Error, info?: ReportInfo): void {
  console.error('[reportError]', error, info);

  if (!import.meta.env.PROD) return;
  try {
    captureException(error, info?.componentStack ?? undefined);
  } catch {
    // Reporting failures must never propagate.
  }
}
